const dateToYMD = (date) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const day = d.getDate();
  return `${y}-${m <= 9 ? "0" + m : m}-${day <= 9 ? "0" + day : day}`;
};

const getAllDatesBetween = (startDate, endDate) => {
  const offSet = new Date().getTimezoneOffset();
  const start = new Date(startDate);
  const end = new Date(endDate);
  start.setMinutes(start.getMinutes() + offSet);
  end.setMinutes(end.getMinutes() + offSet);

  const dayCount =
    Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;

  return Array.from({ length: dayCount }, (_, i) => {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
    return d;
  });
};

export const buildStopSellPayload = ({
  propertyId,
  rateplanIds,
  roomtypeIds,
  dateRanges,
  isOpen,
}) => {
  const productUpdates = [];

  // Find overall date range for the payload envelope
  const allStartDates = dateRanges.map((dr) => new Date(dr[0]));
  const allEndDates = dateRanges.map((dr) => new Date(dr[1]));
  const overallStart = new Date(Math.min(...allStartDates));
  const overallEnd = new Date(Math.max(...allEndDates));

  const allUpdates = dateRanges.flatMap((dr) =>
    getAllDatesBetween(dr[0], dr[1]).map((date) => ({
      date: dateToYMD(date),
      isOpen,
    }))
  );

  rateplanIds.forEach((rateplanId) => {
    roomtypeIds.forEach((roomtypeId) => {
      productUpdates.push({
        rateplanId,
        roomtypeId,
        updates: allUpdates,
      });
    });
  });

  return {
    propertyId,
    dateRange: {
      startDate: dateToYMD(overallStart),
      endDate: dateToYMD(overallEnd),
    },
    productUpdates,
  };
};
